/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RelationshipChange } from './RelationshipChange';
import {
    RelationshipChangeFromJSON,
    RelationshipChangeFromJSONTyped,
    RelationshipChangeToJSON,
    RelationshipChangeToJSONTyped,
} from './RelationshipChange';

/**
 * 
 * @export
 * @interface UpdateRelationshipsRequestDto
 */
export interface UpdateRelationshipsRequestDto {
    /**
     * 
     * @type {Array<RelationshipChange>}
     * @memberof UpdateRelationshipsRequestDto
     */
    changes?: Array<RelationshipChange> | null;
}

/**
 * Check if a given object implements the UpdateRelationshipsRequestDto interface.
 */
export function instanceOfUpdateRelationshipsRequestDto(value: object): value is UpdateRelationshipsRequestDto {
    return true;
}

export function UpdateRelationshipsRequestDtoFromJSON(json: any): UpdateRelationshipsRequestDto {
    return UpdateRelationshipsRequestDtoFromJSONTyped(json, false);
}

export function UpdateRelationshipsRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRelationshipsRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'changes': json['changes'] == null ? undefined : ((json['changes'] as Array<any>).map(RelationshipChangeFromJSON)),
    };
}

export function UpdateRelationshipsRequestDtoToJSON(json: any): UpdateRelationshipsRequestDto {
    return UpdateRelationshipsRequestDtoToJSONTyped(json, false);
}

export function UpdateRelationshipsRequestDtoToJSONTyped(value?: UpdateRelationshipsRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'changes': value['changes'] == null ? undefined : ((value['changes'] as Array<any>).map(RelationshipChangeToJSON)),
    };
}

